import { isoToDateString, isoToDateTimeString, monthEnding } from "utils/date";
    
export default [

  { field: 'createdAt', headerAlign: 'center', headerName: 'Создана', width: 90, 
    valueGetter: (value) => isoToDateString(value) },

  { field: 'license', width: 150, headerName: 'Лицензия', headerAlign: 'center', align: 'center' },


  { field: 'duration', width: 100, headerAlign: 'center', headerName: 'Длительность', align: 'center', 
    valueGetter: (value) => `${value} ${monthEnding(value)}` }, 
    
  { field: 'endActivationAt', headerAlign: 'center', headerName: 'Активация до', width: 100, align: 'right',
    valueGetter: (value) => isoToDateString(value) },
    
  { field: 'subjectType', headerAlign: 'center', headerName: 'Тип лицензии', width: 100, align: 'center',
    valueGetter: (value) => value==='apps' ? 'Приложение' : 'Профиль' },

  { field: 'subject', headerAlign: 'center', headerName: 'Предмет лицензирования', flex: 2, align: 'right'}

];